export function isCloudflareBeaconError(event) {
  const values = event.exception?.values || [];
  const frames = values.flatMap(value => value.stacktrace?.frames || []);
  const knownFailure = values.some(value =>
    /(?:\.at is not a function|Unexpected token ['"]?\.)/.test(value.value || '')
  );
  return knownFailure &&
    frames.some(frame => /\/beacon\.min\.js(?:\/|$|[?#])/.test(frame.filename || '')) &&
    !frames.some(frame => /\/(?:assets|static\/js|_next)\//.test(frame.filename || ''));
}

// One `resource.*` span per script, stylesheet, image and font fetched during
// a page load — ~90% of frontend spans; they exhausted the monthly quota in days.
// Resource spans are leaves, so dropping them orphans nothing.
export function dropResourceSpans(event) {
  if (event.spans) {
    event.spans = event.spans.filter(span => !span.op?.startsWith('resource.'));
  }
  return event;
}
